import { render, staticRenderFns } from "./CompanyGroups.vue?vue&type=template&id=8021bfa0&scoped=true&"
import script from "./CompanyGroups.vue?vue&type=script&lang=js&"
export * from "./CompanyGroups.vue?vue&type=script&lang=js&"
import style0 from "./CompanyGroups.vue?vue&type=style&index=0&id=8021bfa0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8021bfa0",
  null
  
)

export default component.exports